import React from 'react';
import {
  Container, Box, Grid,
} from '@mui/material';
import InfiniteTravelerTripMatchList from '../../../components/infinite-traveler-trip-match-list';
import InfiniteTravelerTripRequestList from '../../../components/infinite-traveler-trip-request-list';

type TripsViewProps = {
  travelerId: string | undefined,
};

const TripsView = ({
  travelerId,
}: TripsViewProps) => (
  <Container maxWidth="xl">
    <Box sx={{
      paddingTop: { desktop: 0, mobile: 0 },
    }}
    >
      <Grid container>
        <Grid item mobile={12} desktop={3} />
      </Grid>
      <Box sx={{ pt: { desktop: 4 } }}>
        <InfiniteTravelerTripRequestList
          travelerId={travelerId}
        />
      </Box>
      <Box>
        <InfiniteTravelerTripMatchList
          travelerId={travelerId}
        />
      </Box>
    </Box>
  </Container>
);

export default TripsView;
